export default __webpack_public_path__ + "static/media/ic-weight.1e433f8b.svg";